import { searchWithoutUiOnlyParams } from './routeLocationChange';

/**
 * Compare locations while ignoring overlay/menu chrome query params.
 *
 * @param {{ pathname?: string, search?: string }} location
 * @returns {string}
 */
export const locationKeyWithoutModalState = (location = {}) => {
  const qs = searchWithoutUiOnlyParams(location.search);
  return `${location.pathname || ''}${qs ? `?${qs}` : ''}`;
};

/**
 * Y position to restore after a modal unlocks body scroll.
 * Stay put if only overlay chrome was removed; go to top if the page/query changed
 * (e.g. a Quick tag opened a fresh Search).
 *
 * @param {Object} args
 * @param {{ pathname?: string, search?: string }} args.lockedLocation
 * @param {{ pathname?: string, search?: string }} args.nextLocation
 * @param {number} [args.savedY]
 * @returns {number}
 */
export const scrollYAfterModalUnlock = ({ lockedLocation, nextLocation, savedY = 0 }) => {
  if (locationKeyWithoutModalState(lockedLocation) !== locationKeyWithoutModalState(nextLocation)) {
    return 0;
  }
  return savedY;
};
